// Ojasvaya — brand assets (user-supplied) + therapy data
export const LOGO = "/brand/ojasvaya-logo.png";
export const LOGO_LIGHT = "/brand/ojasvaya-logo-light.png";

export const IMG = {
  lobby: "https://customer-assets.emergentagent.com/job_wellness-portal-241/artifacts/ur7novlw_WhatsApp%20Image%202026-05-04%20at%206.00.20%20PM-7.jpeg",
  redLight: "https://customer-assets.emergentagent.com/job_wellness-portal-241/artifacts/gj7wga4x_WhatsApp%20Image%202026-05-04%20at%205.59.33%20PM-5.jpeg",
  cryo: "https://customer-assets.emergentagent.com/job_wellness-portal-241/artifacts/irhpxnyn_WhatsApp%20Image%202026-05-04%20at%205.59.58%20PM-6.jpeg",
  hbot: "https://customer-assets.emergentagent.com/job_wellness-portal-241/artifacts/asfmi5ou_WhatsApp%20Image%202026-05-04%20at%205.59.58%20PM-7.jpeg",
  panchakarma: "https://customer-assets.emergentagent.com/job_d79f8c2d-bc9e-43e0-89f9-1f0427aec932/artifacts/snlcbe8k_WhatsApp%20Image%202026-05-04%20at%205.59.30%20PM-3.jpeg",
  hbotLogo: "https://customer-assets.emergentagent.com/job_d79f8c2d-bc9e-43e0-89f9-1f0427aec932/artifacts/mi25ck3a_WhatsApp%20Image%202026-05-04%20at%205.59.31%20PM-4.jpeg",
  banner: "https://customer-assets.emergentagent.com/job_d79f8c2d-bc9e-43e0-89f9-1f0427aec932/artifacts/8kpxjo4d_WhatsApp%20Image%202026-05-04%20at%205.58.55%20PM.jpeg",
};

// Curated stock for therapies we don't have in-house photos for yet
const stock = {
  ozone: "https://images.unsplash.com/photo-1666886573253-2d83de24f2b8?auto=format&fit=crop&w=1400&q=80",
  sauna: "https://images.unsplash.com/photo-1583416750470-965b2707b355?auto=format&fit=crop&w=1400&q=80",
  prp: "https://images.unsplash.com/photo-1614108140096-6e601e1d3a86?auto=format&fit=crop&w=1400&q=80",
  laser: "https://images.unsplash.com/photo-1601049413399-fdcd1be8c34a?auto=format&fit=crop&w=1400&q=80",
  skin: "https://images.unsplash.com/photo-1596178060810-72ee5fa11314?auto=format&fit=crop&w=1400&q=80",
  physio: "https://images.unsplash.com/photo-1599447421416-3414500d18a5?auto=format&fit=crop&w=1400&q=80",
  nutra: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1400&q=80",
  heat: "https://images.unsplash.com/photo-1545205597-3d9d02c29597?auto=format&fit=crop&w=1400&q=80",
  colon: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?auto=format&fit=crop&w=1400&q=80",
  stem: "https://images.unsplash.com/photo-1582719471384-894fbb16e074?auto=format&fit=crop&w=1400&q=80",
  immuno: "https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?auto=format&fit=crop&w=1400&q=80",
  h2: "https://images.unsplash.com/photo-1548839140-29a749e1cf4d?auto=format&fit=crop&w=1400&q=80",
  peptide: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?auto=format&fit=crop&w=1400&q=80",
  eboo: "https://images.unsplash.com/photo-1666214280557-f1b5022eb634?auto=format&fit=crop&w=1400&q=80",
};

export const THERAPIES = [
  { slug: "hbot", name: "Hyperbaric Oxygen", short: "Cellular oxygenation for repair, recovery & longevity.", category: "Detox & Cellular", img: IMG.hbot, featured: true },
  { slug: "cryotherapy", name: "Cryotherapy", short: "Whole-body cold for inflammation, recovery & vitality.", category: "Recovery & Pain", img: IMG.cryo, featured: true },
  { slug: "red-light", name: "Red Light Therapy", short: "Photobiomodulation for skin, mitochondria & healing.", category: "Aesthetic", img: IMG.redLight, featured: true },
  { slug: "panchakarma", name: "Panchakarma", short: "Classical Ayurvedic detox to balance Vata, Pitta, Kapha.", category: "Ayurveda", img: IMG.panchakarma, featured: true },
  { slug: "ozone", name: "Ozone Therapy", short: "Medical O₃ for immunity, oxygen utilisation & detox.", category: "Detox & Cellular", img: stock.ozone, featured: true },
  { slug: "eboo", name: "EBOO Therapy", short: "Extra-corporeal blood ozonation & filtration.", category: "Detox & Cellular", img: stock.eboo, featured: true },
  { slug: "stem-cell", name: "Stem Cell Therapy", short: "Regenerative cells for tissue repair & longevity.", category: "Regenerative", img: stock.stem },
  { slug: "immunotherapy", name: "Immunotherapy", short: "Targeted immune modulation & resilience.", category: "Regenerative", img: stock.immuno },
  { slug: "h2", name: "H₂ Molecular Hydrogen", short: "Selective antioxidant for oxidative stress.", category: "Detox & Cellular", img: stock.h2 },
  { slug: "peptide", name: "Peptide Therapy", short: "Bio-active peptides for performance & repair.", category: "Regenerative", img: stock.peptide },
  { slug: "skin-rejuvenation", name: "Skin Rejuvenation", short: "Advanced aesthetics for radiant, youthful skin.", category: "Aesthetic", img: stock.skin },
  { slug: "laser", name: "Laser Therapies", short: "Precision laser for skin, scars & pigmentation.", category: "Aesthetic", img: stock.laser },
  { slug: "infrared-sauna", name: "Infrared & Sauna", short: "Deep heat detox, circulation & recovery.", category: "Recovery & Pain", img: stock.sauna },
  { slug: "heat-therapy", name: "Heat Therapy", short: "Therapeutic heat for muscles, joints & circulation.", category: "Recovery & Pain", img: stock.heat },
  { slug: "physiotherapy", name: "Physiotherapy", short: "Personalised rehab for movement & function.", category: "Recovery & Pain", img: stock.physio },
  { slug: "prp", name: "PRP Therapy", short: "Platelet-rich plasma for hair & skin renewal.", category: "Aesthetic", img: stock.prp },
  { slug: "nutraceutical", name: "Nutraceutical Therapy", short: "Therapeutic nutrition for cellular vitality.", category: "Ayurveda", img: stock.nutra },
  { slug: "colon-hydrotherapy", name: "Colon Hydrotherapy", short: "Gentle colon cleansing for gut reset.", category: "Detox & Cellular", img: stock.colon },
];

export const PILLARS = [
  { name: "Integrative Medicine", desc: "Modern diagnostics meet root-cause healing." },
  { name: "Ayurveda & Panchakarma", desc: "Classical detox in a contemporary clinic." },
  { name: "Ozone Therapy", desc: "Cellular oxygenation & deep detoxification." },
  { name: "Hyperbaric Oxygen", desc: "Pressurised O₂ for repair & longevity." },
  { name: "Preventive Wellness", desc: "Personalised protocols for lasting vitality." },
];

export const PROGRAMS = [
  {
    title: "Detox Reset",
    duration: "7 / 14 / 21 days",
    desc: "A guided cellular & gut detox combining Panchakarma, Ozone, EBOO and infrared sauna for a complete internal reset.",
    color: "emerald",
  },
  {
    title: "Longevity 360",
    duration: "Quarterly programme",
    desc: "Anti-aging protocol pairing Hyperbaric Oxygen, Stem Cell & Peptide therapy with bespoke nutrition and biomarkers.",
    color: "gold",
  },
  {
    title: "Recovery & Performance",
    duration: "Per-session / packages",
    desc: "For athletes & high-performers — Cryotherapy, Red Light, Physiotherapy and PRP for faster, deeper recovery.",
    color: "emerald",
  },
];

export const TESTIMONIALS = [
  {
    quote: "After my third HBOT session at Ojasvaya I felt a clarity I hadn't experienced in years. The team treats every guest like a story, not a chart.",
    name: "Anika M.",
    role: "Entrepreneur, Mumbai",
  },
  {
    quote: "Their Panchakarma programme is the most authentic I've seen outside Kerala — paired with diagnostics that finally explained my fatigue.",
    name: "Dr. R. Iyer",
    role: "Cardiologist",
  },
  {
    quote: "Cryo + Red Light twice a week has changed my recovery completely. The space itself is unlike any clinic in the city.",
    name: "Vikram S.",
    role: "Marathon runner",
  },
];
